// import React from 'react';
// import { Link } from 'react-router-dom';
// import './FeeStructurePage.css';
// import Navbar from './Navbar';
// import FooterSection from './FooterSection';

// export default function FeeStructurePage() {
//   const ugPrograms = [
//     { program: 'BA (All Subjects)', duration: '3 Years', semFee: '₹2,400', totalFee: '₹14,400', regFee: '₹200', examFee: '₹400/sem' },
//     { program: 'BCom', duration: '3 Years', semFee: '₹2,600', totalFee: '₹15,600', regFee: '₹200', examFee: '₹400/sem' },
//     { program: 'BBA', duration: '3 Years', semFee: '₹3,000', totalFee: '₹18,000', regFee: '₹200', examFee: '₹400/sem' },
//     { program: 'BCA', duration: '3 Years', semFee: '₹3,750', totalFee: '₹22,500', regFee: '₹200', examFee: '₹500/sem' },
//     { program: 'BSc (Computer Science)', duration: '3 Years', semFee: '₹3,250', totalFee: '₹19,500', regFee: '₹200', examFee: '₹450/sem' },
//     { program: 'BSc (Mathematics)', duration: '3 Years', semFee: '₹2,750', totalFee: '₹16,500', regFee: '₹200', examFee: '₹400/sem' },
//   ];

//   const pgPrograms = [
//     { program: 'MA (English / Tamil / Economics etc.)', duration: '2 Years', semFee: '₹3,000', totalFee: '₹12,000', regFee: '₹300', examFee: '₹500/sem' },
//     { program: 'MCom', duration: '2 Years', semFee: '₹3,250', totalFee: '₹13,000', regFee: '₹300', examFee: '₹500/sem' },
//     { program: 'MBA', duration: '2 Years', semFee: '₹6,000', totalFee: '₹24,000', regFee: '₹500', examFee: '₹700/sem' },
//     { program: 'MCA', duration: '2 Years', semFee: '₹7,000', totalFee: '₹28,000', regFee: '₹500', examFee: '₹700/sem' },
//     { program: 'MSc (Computer Science)', duration: '2 Years', semFee: '₹4,000', totalFee: '₹16,000', regFee: '₹300', examFee: '₹500/sem' },
//     { program: 'MSW', duration: '2 Years', semFee: '₹3,500', totalFee: '₹14,000', regFee: '₹300', examFee: '₹500/sem' },
//   ];

//   const diplomaPrograms = [
//     { program: 'PGDCA', duration: '1 Year', semFee: '₹5,000', totalFee: '₹5,000', regFee: '₹200', examFee: '₹400' },
//     { program: 'PGDBM', duration: '1 Year', semFee: '₹5,000', totalFee: '₹5,000', regFee: '₹200', examFee: '₹400' },
//     { program: 'PGDJ', duration: '1 Year', semFee: '₹4,500', totalFee: '₹4,500', regFee: '₹200', examFee: '₹400' },
//   ];

//   const certPrograms = [
//     { program: 'Certificate in Spoken English', duration: '6 Months', semFee: '₹2,500', totalFee: '₹2,500', regFee: '₹150', examFee: '₹300' },
//     { program: 'Certificate in Computer Applications', duration: '6 Months', semFee: '₹2,500', totalFee: '₹2,500', regFee: '₹150', examFee: '₹300' },
//     { program: 'Certificate in Journalism', duration: '6 Months', semFee: '₹3,000', totalFee: '₹3,000', regFee: '₹150', examFee: '₹300' },
//   ];

//   const paymentMethods = [
//     'Net Banking', 'UPI / BHIM', 'Credit Card', 'Debit Card',
//     'Demand Draft', 'Online Portal', 'Study Centre', 'Post Office'
//   ];

//   // Reusable Table Component to keep code clean and DRY
//   const FeeTable = ({ title, data, themeClass }) => (
//     <div className="fee-category-section">
//       <div className={`category-header ${themeClass}-title`}>
//         <h2>{title}</h2>
//       </div>
//       <div className="table-responsive-wrapper">
//         <table className={`fee-data-table ${themeClass}-table`}>
//           <thead>
//             <tr>
//               <th className="col-program">Program</th>
//               <th className="col-duration">Duration</th>
//               <th className="col-sem">Sem / Annual Fee</th>
//               <th className="col-total">Total Fee</th>
//               <th className="col-reg">Registration Fee</th>
//               <th className="col-exam">Exam Fee</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((row, index) => (
//               <tr key={index}>
//                 <td className="col-program font-medium">{row.program}</td>
//                 <td>{row.duration}</td>
//                 <td className="highlight-text">{row.semFee}</td>
//                 <td className="highlight-text-bold">{row.totalFee}</td>
//                 <td>{row.regFee}</td>
//                 <td>{row.examFee}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );

//   return (
//       <>
//          <Navbar />
//     <div className="fee-structure-page">
      
//       {/* 1. Header Banner */}
//       <section className="fee-hero-banner">
//         <div className="banner-inner-container">
//           <div className="banner-left-content">
//             <nav className="breadcrumb-nav">
//               <Link to="/" className="breadcrumb-link">Home</Link> / <span>Fee Structure</span>
//             </nav>
//             <h1>Fee Structure</h1>
//             <p className="subtitle-session">
//               Academic Year 2025–26 | All fee amounts in Indian Rupees (₹)
//             </p>
//           </div>
//           <div className="banner-right-content">
//             <a href="#download-pdf" className="btn-top-download">
//               <span className="dl-icon">📥</span> Download Fee PDF
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* 2. Disclaimer Strip */}
//       <div className="fee-disclaimer-strip">
//         <div className="container-constraint">
//           <span className="info-icon">ℹ️</span>
//           <p>
//             Fees mentioned are subject to change. SC/ST candidates may be eligible for fee concessions as per government norms. Contact CDOE for details.
//           </p>
//         </div>
//       </div>

//       {/* 3. Main Tables Section */}
//       <section className="fee-tables-container">
//         <div className="container-constraint">
          
//           <FeeTable title="Undergraduate Programs" data={ugPrograms} themeClass="theme-ug" />
//           <FeeTable title="Postgraduate Programs" data={pgPrograms} themeClass="theme-pg" />
//           <FeeTable title="Diploma Programs" data={diplomaPrograms} themeClass="theme-dip" />
//           <FeeTable title="Certificate Programs" data={certPrograms} themeClass="theme-cert" />

//           {/* 4. Payment Methods Box */}
//           <div className="payment-methods-box">
//             <h3 className="payment-title">Payment Methods Accepted</h3>
            
//             <div className="payment-grid">
//               {paymentMethods.map((method, idx) => (
//                 <div key={idx} className="payment-pill">
//                   {method}
//                 </div>
//               ))}
//             </div>
            
//             <p className="payment-footer-note">
//               * DD should be drawn in favor of "The Director, CDOE, EDULEARNER" payable at Thiruvannamalai.
//             </p>
//           </div>

//         </div>
//       </section>
      
//     </div>
//     <FooterSection/>
//             </>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './FeeStructurePage.css';
import Navbar from './Navbar';
import FooterSection from './FooterSection';

export default function FeeStructurePage() {
  const [coursesData, setCoursesData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch dynamic courses from API
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/courses/courses');
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setCoursesData(result.data);
        }
      } catch (error) {
        console.error('Error fetching fee structure courses:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  // Helper function to format row data dynamically
  const formatCourseRow = (course) => {
    const annualFee = Number(course.total_course_fee) || 0;
    const durationYears = Number(course.minimum_duration) || 1;
    const totalProgramFee = annualFee;

    return {
      program: course.course_name,
      duration: `${course.minimum_duration} ${durationYears > 1 ? 'Years' : 'Year'}`,
      semFee: `₹${annualFee.toLocaleString('en-IN')}`,
      totalFee: `₹${totalProgramFee.toLocaleString('en-IN')}`,
      regFee: '₹200', // Standard baseline fee
      examFee: '₹400/sem' // Standard baseline fee
    };
  };

  // Group fetched courses by program_type
  const ugPrograms = coursesData
    .filter((c) => c.program_type?.toLowerCase().includes('under-graduate') || c.program_type?.toLowerCase().includes('ug'))
    .map(formatCourseRow);

  const pgPrograms = coursesData
    .filter((c) => c.program_type?.toLowerCase().includes('post-graduate') || c.program_type?.toLowerCase().includes('pg'))
    .map(formatCourseRow);

  const diplomaPrograms = coursesData
    .filter((c) => c.program_type?.toLowerCase().includes('diploma'))
    .map(formatCourseRow);

  const certPrograms = coursesData
    .filter((c) => c.program_type?.toLowerCase().includes('certificate'))
    .map(formatCourseRow);

  const paymentMethods = [
    'Net Banking', 'UPI / BHIM', 'Credit Card', 'Debit Card',
    'Demand Draft', 'Online Portal', 'Study Centre', 'Post Office'
  ];

  // Reusable Table Component
  const FeeTable = ({ title, data, themeClass }) => {
    if (!data || data.length === 0) return null;

    return (
      <div className="fee-category-section">
        <div className={`category-header ${themeClass}-title`}>
          <h2>{title}</h2>
        </div>
        <div className="table-responsive-wrapper">
          <table className={`fee-data-table ${themeClass}-table`}>
            <thead>
              <tr>
                <th className="col-program">Program</th>
                <th className="col-duration">Duration</th>
                {/* <th className="col-sem">Sem / Annual Fee</th> */}
                <th className="col-total">Total Fee</th>
                {/* <th className="col-reg">Registration Fee</th>
                <th className="col-exam">Exam Fee</th> */}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td className="col-program font-medium">{row.program}</td>
                  <td>{row.duration}</td>
                  {/* <td className="highlight-text">{row.semFee}</td> */}
                  <td className="highlight-text-bold">{row.totalFee}</td>
                  {/* <td>{row.regFee}</td>
                  <td>{row.examFee}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <div className="fee-structure-page">
        
        {/* 1. Header Banner */}
        <section className="fee-hero-banner">
          <div className="banner-inner-container">
            <div className="banner-left-content">
              <nav className="breadcrumb-nav">
                <Link to="/" className="breadcrumb-link">Home</Link> / <span>Fee Structure</span>
              </nav>
              <h1>Fee Structure</h1>
              <p className="subtitle-session">
                Academic Year 2025–26 | All fee amounts in Indian Rupees (₹)
              </p>
            </div>
            <div className="banner-right-content">
              <a href="#download-pdf" className="btn-top-download">
                <span className="dl-icon">📥</span> Download Fee PDF
              </a>
            </div>
          </div>
        </section>

        {/* 2. Disclaimer Strip */}
        <div className="fee-disclaimer-strip">
          <div className="container-constraint">
            <span className="info-icon">ℹ️</span>
            <p>
              Fees mentioned are subject to change. SC/ST candidates may be eligible for fee concessions as per government norms. Contact CDOE for details.
            </p>
          </div>
        </div>

        {/* 3. Main Tables Section */}
        <section className="fee-tables-container">
          <div className="container-constraint">
            
            {loading ? (
              <div style={{ textAlign: 'center', padding: '40px 0', fontFamily: 'Inter, sans-serif', color: '#556275' }}>
                <h3>Loading Fee Structure...</h3>
              </div>
            ) : (
              <>
                <FeeTable title="Undergraduate Programs" data={ugPrograms} themeClass="theme-ug" />
                <FeeTable title="Postgraduate Programs" data={pgPrograms} themeClass="theme-pg" />
                <FeeTable title="Diploma Programs" data={diplomaPrograms} themeClass="theme-dip" />
                <FeeTable title="Certificate Programs" data={certPrograms} themeClass="theme-cert" />
              </>
            )}

            {/* 4. Payment Methods Box */}
            <div className="payment-methods-box">
              <h3 className="payment-title">Payment Methods Accepted</h3>
              
              <div className="payment-grid">
                {paymentMethods.map((method, idx) => (
                  <div key={idx} className="payment-pill">
                    {method}
                  </div>
                ))}
              </div>
              
              <p className="payment-footer-note">
                * DD should be drawn in favor of "The Director, CDOE, EDULEARNER" payable at Thiruvannamalai.
              </p>
            </div>

          </div>
        </section>
        
      </div>
      <FooterSection />
    </>
  );
}